import { render } from "./Restaurant.vue?vue&type=template&id=06714e44&scoped=true"
import script from "./Restaurant.vue?vue&type=script&lang=js"
export * from "./Restaurant.vue?vue&type=script&lang=js"

import "./Restaurant.vue?vue&type=style&index=0&id=06714e44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06714e44"]])

export default __exports__